<template>
  <div>
    <h2>Teksty</h2>
    <el-card class="box-card text" v-for="(text, index) in texts" :key="index">
        <q v-html="renderText(text)"></q>
        <div class="buttons">
          <el-button type="success" @click="createText(text)" size="mini">Dodaj</el-button>
          <el-button type="primary" @click="setText(text)" size="mini">Wybieram</el-button>
        </div>
    </el-card>
  </div>
</template>

<script>
  import Editor from '../../classes/Editor'

  export default {
    data() {
      return {
        texts: [
          'Aleksandra Kowalska\n&\nMateusz Nowak\nw imieniu rodziców i własnym\nz radością zapraszają\nSz. P. .......................................\nna swój Ślub,\nktóry odbędzie się dnia 1 lipca 2016 roku\no godzinie 13.00 w Kościele Św. Pawła w Laskach',
          'Maria i Janusz Kowalscy\noraz\nKrystyna i Tadeusz Nowakowie\nmają zaszczyt zaprosić\nSz. P. ...........................................\nna Ślub swoich dzieci\nAleksandry Kowalskiej i Mateusza Nowak\nktóry odbędzie się dnia 18 grudnia 2016 roku\no godzinie 17.00 w Kościele Św. Franciszka\nprzy ulicy Nowej w Adamowie',
          'Zakochani i świadomi, że ich miłość to nie wiatr,\nmają zaszczyt zawiadomić, że chcą razem iść przez świat.\nAleksandra Kowalska\ni\nMateusz Nowakserdecznie zapraszają\nSz. P. ............................................................................\nna uroczystość Zaślubin,\nktóra odbędzie się 11 sierpnia 2016 roku o godzinie 12.00\nw Kościele Św. Jacka w Policach ',
          'By obyczajom prastarym zadość uczynić, wszem i wobec ogłaszają,\nże dnia 8 października 2003 roku o godzinie 12.00\nw Kaplicy Św. Jana Chrzciciela w Borach\nślubować sobie będą miłość i wierność małżeńską\nAleksandra Kowalska\ni\nMateusz Nowak\nNa uroczystość tę mają zaszczyt zaprosić\nSz. P. ............................................................................\nRodzice i Narzeczeni. ',
        ]
      };
    },
    methods: {
      setText(text) {
        if (! Editor.canvas.getActiveObject()) {
          this.$alert('Wybierz pole tekstowe w którym wstawić wybrany tekst.', 'Ups...', {
            confirmButtonText: 'OK',
            type: 'warning',
          });
        } else {
          Editor.setText(text);
        }
      },
      createText(text) {
        Editor.addText(text, {
          textAlign: 'center',
          fontSize: 16,
          width: 400
        })
      },
      renderText(text) {
        return text.replace(/\\n/g, '<br />');
      }
    }
  }
</script>

<style lang="less">
  .box-card {
    &.text {
      .el-card__body {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .buttons {
        margin-top: 15px;
      }
      + .text {
        margin-top: 15px;
      }
      q {
        width: 100%;
        font-size: 10px;
        text-align: center;
      }
    }
  }
</style>